module.exports = __webpack_public_path__ + "img/Platzhalter.3375f0da.svg";